import {
  MatrixBackdrop,
  MatrixCard,
  MatrixChrome,
  MatrixHero,
  MatrixSectionHeader,
} from "./matrix/MatrixSlots";
import {
  AlienBackdrop,
  AlienCard,
  AlienChrome,
  AlienHero,
  AlienSectionHeader,
} from "./alien/AlienSlots";
import {
  ConjuringBackdrop,
  ConjuringCard,
  ConjuringChrome,
  ConjuringHero,
  ConjuringSectionHeader,
} from "./conjuring/ConjuringSlots";
import {
  ShiningBackdrop,
  ShiningCard,
  ShiningChrome,
  ShiningHero,
  ShiningSectionHeader,
} from "./shining/ShiningSlots";
import { THEME_IDS, type Theme, type ThemeId } from "./types";
import "./tokens.css";

/**
 * The theme registry — the single place a theme id maps to anything.
 *
 * Accent values mirror each block's --color-accent in tokens.css. The
 * duplication is unavoidable — the switcher paints every theme's swatch while
 * only one theme's tokens are live — but it does drift: Alien was repaletted
 * from amber to cyan and this copy was missed, leaving the wrong colour in the
 * switcher. Change both together.
 *
 * fontHref is loaded lazily on activation, so five themes do not mean five
 * font payloads on every visit. Matrix and Alien reuse fonts the page already
 * loads and so declare none.
 */
export const THEMES: Record<ThemeId, Theme> = {
  matrix: {
    id: "matrix",
    label: "The Matrix",
    accent: "#00ff41",
    Hero: MatrixHero,
    SectionHeader: MatrixSectionHeader,
    Card: MatrixCard,
    Backdrop: MatrixBackdrop,
    Chrome: MatrixChrome,
  },
  alien: {
    id: "alien",
    label: "Alien",
    accent: "#5fd3c8",
    Hero: AlienHero,
    SectionHeader: AlienSectionHeader,
    Card: AlienCard,
    Backdrop: AlienBackdrop,
    Chrome: AlienChrome,
  },
  conjuring: {
    id: "conjuring",
    label: "The Conjuring",
    accent: "#d9b382",
    fontHref:
      "https://fonts.googleapis.com/css2?family=IM+Fell+English:ital@0;1&display=swap",
    Hero: ConjuringHero,
    SectionHeader: ConjuringSectionHeader,
    Card: ConjuringCard,
    Backdrop: ConjuringBackdrop,
    Chrome: ConjuringChrome,
  },
  shining: {
    id: "shining",
    label: "The Shining",
    accent: "#b0161c",
    fontHref:
      "https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@500;600;700&family=Special+Elite&display=swap",
    Hero: ShiningHero,
    SectionHeader: ShiningSectionHeader,
    Card: ShiningCard,
    Backdrop: ShiningBackdrop,
    Chrome: ShiningChrome,
  },
};

export const THEME_LIST: Theme[] = THEME_IDS.map((id) => THEMES[id]);
